var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5500",
    "data-name": "Group 5500",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.46,
    height: 50.075,
    viewBox: "0 0 48.46 50.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M180.4,392.483a.81.81,0,0,1-.106-.007l-.45-.06H167.018a.808.808,0,0,1-.808-.82l.067-4.472c0-3.813,3.466-5.584,5.564-6.043a8.259,8.259,0,0,1,3.819,0c2.1.463,5.551,2.236,5.551,6.052v4.539a.809.809,0,0,1-.808.808ZM167.838,390.8H179.6v-3.664c0-3.541-4.165-4.451-4.343-4.488a.818.818,0,0,1-.217-.078,8.185,8.185,0,0,0-2.639.026,1.564,1.564,0,0,1-.162.052c-.178.038-4.343.948-4.343,4.488Zm0,0",
    transform: "translate(-149.48 -342.408)",
    fill: "#fe4e4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M203.509,294.074a4.17,4.17,0,1,1,4.154-4.169A4.166,4.166,0,0,1,203.509,294.074Zm0-6.724a2.554,2.554,0,1,0,2.539,2.555A2.55,2.55,0,0,0,203.509,287.35Zm0,0",
    transform: "translate(-179.279 -256.887)",
    fill: "#fe4e4e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M346.124,392.478a.827.827,0,0,1-.107-.007l-.448-.06H332.741a.808.808,0,0,1-.808-.82L332,387.12c0-3.813,3.466-5.584,5.564-6.043a8.223,8.223,0,0,1,3.818,0c2.1.462,5.55,2.234,5.55,6.052v4.539a.808.808,0,0,1-.808.808ZM333.559,390.8h11.757v-3.664c0-3.541-4.165-4.451-4.343-4.488a.8.8,0,0,1-.217-.079,8.267,8.267,0,0,0-2.637.026,1.407,1.407,0,0,1-.162.052c-.178.037-4.343.947-4.343,4.488Zm0,0",
    transform: "translate(-298.472 -342.403)",
    fill: "#fe4e4e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M369.224,294.074a4.17,4.17,0,1,1,4.155-4.169A4.166,4.166,0,0,1,369.224,294.074Zm0-6.724a2.554,2.554,0,1,0,2.539,2.555A2.55,2.55,0,0,0,369.224,287.35Zm0,0",
    transform: "translate(-328.264 -256.887)",
    fill: "#fe4e4e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M14.691,392.478a.832.832,0,0,1-.108-.007l-.448-.06H1.307a.808.808,0,0,1-.808-.82l.067-4.472c0-3.813,3.466-5.584,5.564-6.043a8.223,8.223,0,0,1,3.818,0c2.1.462,5.551,2.235,5.551,6.052v4.539a.808.808,0,0,1-.808.808ZM2.127,390.8H13.884v-3.664c0-3.541-4.165-4.451-4.343-4.488a.8.8,0,0,1-.217-.079,8.267,8.267,0,0,0-2.637.026,1.39,1.39,0,0,1-.162.052c-.177.037-4.343.947-4.343,4.488Zm0,0",
    transform: "translate(-0.499 -342.403)",
    fill: "#fe4e4e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M37.791,294.074a4.17,4.17,0,1,1,4.154-4.169A4.167,4.167,0,0,1,37.791,294.074Zm0-6.724A2.554,2.554,0,1,0,40.33,289.9,2.551,2.551,0,0,0,37.791,287.35Zm0,0",
    transform: "translate(-30.291 -256.887)",
    fill: "#fe4e4e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M293.516,98.48h1.615v8.229h-1.615Zm0,0",
    transform: "translate(-263.933 -88.538)",
    fill: "#fe4e4e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M325.8,127.754h1.615v5.274H325.8Zm0,0",
    transform: "translate(-292.955 -114.856)",
    fill: "#fe4e4e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M356.9,103.625h1.615v7.71H356.9Zm0,0",
    transform: "translate(-320.921 -93.163)",
    fill: "#fe4e4e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M399.8,41.879h1.615V55.823H399.8Zm0,0",
    transform: "translate(-359.492 -37.651)",
    fill: "#fe4e4e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M185.981,21.79H162.513a.808.808,0,0,1,0-1.615h22.661V1.615H158.045V16.267a.808.808,0,1,1-1.615,0V.808A.807.807,0,0,1,157.237,0h28.744a.807.807,0,0,1,.808.808V20.982A.807.807,0,0,1,185.981,21.79Zm0,0",
    transform: "translate(-140.687 0)",
    fill: "#fe4e4e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M53.839,22.136a4.548,4.548,0,1,1,4.53-4.549A4.544,4.544,0,0,1,53.839,22.136Zm0-7.482a2.933,2.933,0,1,0,2.915,2.933A2.927,2.927,0,0,0,53.839,14.654Zm0,0",
    transform: "translate(-44.381 -11.723)",
    fill: "#fe4e4e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M27.11,128.107H18.416a.807.807,0,0,1-.808-.808v-1.23a2.312,2.312,0,0,1-3.011-2.253V119.9a10.958,10.958,0,0,1,1.925-6.222,3.882,3.882,0,0,1,1.682-1.405,5.47,5.47,0,0,1,2.135-.43h4.827c.119,0,.239,0,.358.015a4.47,4.47,0,0,1,3.368,2.119l1.815,2.886,3.587,1.955a2.845,2.845,0,0,1,1.39,3.377,2.776,2.776,0,0,1-3.675,1.7.611.611,0,0,1-.084-.041l-3.99-2.182-.017,5.622A.809.809,0,0,1,27.11,128.107Zm-7.886-1.615H26.3l.018-6.175,0-1.26a.807.807,0,0,1,.808-.8h0a.807.807,0,0,1,.805.808v0l0,.779,4.713,2.578a1.133,1.133,0,0,0,.879-.037,1.16,1.16,0,0,0,.62-.694,1.248,1.248,0,0,0-.631-1.448l-3.772-2.055a.808.808,0,0,1-.3-.28l-1.928-3.063a2.846,2.846,0,0,0-2.131-1.369c-.076-.007-.152-.01-.228-.01H20.339a3.878,3.878,0,0,0-1.508.3,2.266,2.266,0,0,0-.976.829,9.359,9.359,0,0,0-1.643,5.309v3.914a.731.731,0,0,0,.544.729.7.7,0,0,0,.851-.689v-5.373a.808.808,0,1,1,1.615,0Zm0,0",
    transform: "translate(-13.174 -100.556)",
    fill: "#fe4e4e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M196.855,114.96l5.453-8.093,1.339.9-5.453,8.093Zm0,0",
    transform: "translate(-177.032 -96.078)",
    fill: "#fe4e4e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.333929f6c4f514c0587b4a6b2ca1ea98.svg";
export { ForwardRef as ReactComponent };